export const baseBackendURL = (process.env.REACT_APP_BASE_BACKEND_URL || "https://api.callhq.ai") + "/api/";
export const apiToken = localStorage.getItem('token') || '';
  export const callBackendUrl = `${baseBackendURL}calls`;
export const analyticsBackendUrl = `${baseBackendURL}analytics`;
export const analyticsOrgBackendUrl = `${baseBackendURL}analytics/dashboard`;
export const callDetailWithId = `${baseBackendURL}calls/details?id=`
export const callStatsUrl = `${baseBackendURL}analytics/org-call-stats`;
// Authentication
export const signInUrl = `${baseBackendURL}auth/login`

// Organisation
export const addOrganisationUrl = `${baseBackendURL}organizations`
export const getAllOrganisationDataUrl = `${baseBackendURL}organizations`
export const deleteOrganisationDataUrl = `${baseBackendURL}organizations/`
export const getOrganisationUrl = `${baseBackendURL}organizations/`


// Assistants
export const getAllAssistantUrl = `${baseBackendURL}assistants`
export const assistantUrl = `${baseBackendURL}assistants`

// Users
export const getAllUser = `${baseBackendURL}user`
export const addUser = `${baseBackendURL}auth/register`
export const onBoardURL = `${baseBackendURL}auth/onboard`
export const getUserProfile = `${baseBackendURL}user/profile`
export const editUserProfile = `${baseBackendURL}user/profile`
export const changePasswordURL = `${baseBackendURL}user/change-password`

// Integration
export const registerIntegrationUrl = `${baseBackendURL}integrations`
export const getIntegrationUrl = `${baseBackendURL}integrations`

// Roles
export const getRoles = `${baseBackendURL}roles`

// Phone number 
export const phoneNumberURL = `${baseBackendURL}phone-numbers`
export const phoneNumberByOrgIdURL = `${baseBackendURL}phone-numbers/organization/`;


// calls
export const getOutbondCallURL = `${baseBackendURL}calls/outbound`

// verrify phone number 
export const sendOTPURL = `${baseBackendURL}phone-verification/send`;
export const verifyOTPURL = `${baseBackendURL}phone-verification/verify`;
export const isVerifiedURL = `${baseBackendURL}phone-verification/is-verified`;

//ledger
export const ledgerURLWithOrg = `${baseBackendURL}credit-ledger/entries/`;

//wallet
export const walletUrl = `${baseBackendURL}credit-purchases/wallet/`;

// callStats by org id
export const callStatsByOrgIdUrl = `${baseBackendURL}analytics/dashboard`;

// promo code
export const promoCodeUrl = `${baseBackendURL}promo-codes`;
export const validatePromoCodeUrl = `${baseBackendURL}promo-codes/validate/`;

// pricing tiers
export const pricingTiersUrl = `${baseBackendURL}pricing-tiers`;

// payment razorpay
export const paymentRazorpayUrl = `${baseBackendURL}razorpay/`;
export const razorPayInitiatePaymentUrl = `${paymentRazorpayUrl}initiate-payment`;
export const razorPayPaymentStatusUrl = `${paymentRazorpayUrl}status/`;

// payment 
export const paymentPhonepeUrl = `${baseBackendURL}phonepe/`;
export const phonepeInitiatePaymentUrl = `${paymentPhonepeUrl}initiate-payment`;
export const phonepePaymentStatusUrl = `${paymentPhonepeUrl}status/`;

// credit purhcase
export const creditPurchaseUrl = `${baseBackendURL}credit-purchases/`;
export const calculatePricingUrl = `${creditPurchaseUrl}calculate-pricing`;
export const validatePromoWithPurchaseUrl = `${creditPurchaseUrl}validate-promo`;

// session api
export const sessionApiUrl = `${baseBackendURL}sessions`;

// chat api
export const chatApiUrl = `${baseBackendURL}chats`;
export const chatSessionURl = `${chatApiUrl}/session/`


// knowledge base files
export const filesUrl = `${baseBackendURL}files`;

// whatsapp
export const whatsappNumberUrl = `${baseBackendURL}whatsapp-numbers`;
export const assignAssistantToWhatsappNumberUrl = (assistantId) => `${baseBackendURL}whatsapp-numbers/${assistantId}/assign-assistant`;
export const whatsappNumberById = (whatsappNumberId) => `${baseBackendURL}whatsapp-numbers/${whatsappNumberId}`;

// whatsapp config
export const whatsappConfigUrl = 'https://whatsapp-node-callhq-385086326930.asia-south1.run.app'

// whatsapp auth endpoints
export const whatsappAuthBaseUrl = whatsappConfigUrl;
export const whatsappHealthCheckUrl = `${whatsappAuthBaseUrl}/`;
export const whatsappQRCodeUrl = `${whatsappAuthBaseUrl}/whatsapp/qr`;
export const whatsappStatusUrl = `${whatsappAuthBaseUrl}/whatsapp/status`;
export const whatsappConnectUrl = `${whatsappAuthBaseUrl}/whatsapp/connect`;
export const whatsappReconnectUrl = `${whatsappAuthBaseUrl}/whatsapp/reconnect`;
export const whatsappDisconnectUrl = `${whatsappAuthBaseUrl}/whatsapp/disconnect`;

// campaigns
export const campaignUrl = `${baseBackendURL}campaigns`;
export const CampaignByIdUrl = (id) => `${campaignUrl}/${id}`;